"use client"

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SessionProvider } from 'next-auth/react'
import { ThemeProvider } from '@/components/theme-provider'
import { SessionMonitor } from '@/components/session-monitor'
import { useState } from 'react'
import { AudioPlayerProvider } from '@/components/audio-player-provider'
import { GlobalAudioModal } from '@/components/global-audio-modal'
import { MiniAudioPlayer } from '@/components/mini-audio-player'
import { AnalyticsProvider } from '@/components/analytics-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        retry: 1,
      },
    },
  }))

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider>
          <AudioPlayerProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <SessionMonitor />
              <GlobalAudioModal />
              <MiniAudioPlayer />
          {children}
        </ThemeProvider>
          </AudioPlayerProvider>
        </AnalyticsProvider>
      </QueryClientProvider>
    </SessionProvider>
  )
}
